export default "__VITE_ASSET__N9o2yoUy__"